import { put, takeLatest, call } from 'redux-saga/effects';
import * as orderService from '../../../services/orderService';
import {
  DELETE_ORDER_COMMENT,
  DELETE_ORDER_COMMENT_SUCCESS,
  DELETE_ORDER_COMMENT_ERROR,
} from '../../actions/order';

function* deleteOrderCommentSaga(action) {
  try {
    const data = yield call(orderService.DeleteOrderComment, action.payload);

    yield put({
      type: DELETE_ORDER_COMMENT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: DELETE_ORDER_COMMENT_ERROR,
      error: error.data,
    });
  }
}

export function* deleteOrderCommentSagaWatcher() {
  yield takeLatest(DELETE_ORDER_COMMENT, deleteOrderCommentSaga);
}
